import { Box, Typography, useTheme } from "@mui/material";
import { TextOverflow, formatNumber, formatPercent } from "vig-ui-library";

export type StatisticsCardProps = {
    title: string;
    count: number;
    percentage: number;
    percentageColor?: string;
    accentColor?: boolean;
}

export const StatisticsCard = ({ title, count, percentage, ...restProps }: StatisticsCardProps) => {
    const theme = useTheme();

    const percentageColor = restProps.percentageColor || theme.palette.text.secondary;

    const titleColor = restProps.accentColor ? theme.palette.grey[300] : theme.palette.text.secondary;

    const countColor = restProps.accentColor ? theme.palette.common.white : theme.palette.text.primary;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                paddingX: 3,
                paddingY: 1.5,
                width: { sm: 170, xl: 200 },
                borderRadius: `${theme.shape.borderRadius * 2}px`,
                border: `1px solid ${theme.palette.divider}`,
                ["> *"]: { lineHeight: 1 },
                ...restProps.accentColor && {
                    backgroundColor: theme.palette.common.black,
                    borderColor: theme.palette.common.black,
                },
            }}
        >
            <TextOverflow
                variant="body2"
                fontSize={14}
                color={titleColor}
                maxWidth="100%"
                text={title}
            />

            <Typography variant="h4" color={countColor}>{formatNumber(count)}x</Typography>

            <Typography variant="body2" fontWeight={500} color={percentageColor}>{formatPercent(percentage / 100)}</Typography>
        </Box>
    )
}